<script lang="ts">
  export let carretPosition: number;
</script>

<div class="container">
  <div class="text-bubble" style="--carret-position: {carretPosition}%">
    <slot />
  </div>
</div>

<style>
  @keyframes scaleup {
    from {
      transform: scale(0);
    }
    to {
      transform: scale(1);
    }
  }
  .container {
    height: 0;
    position: relative;
    width: 100%;
    top: -5rem;
    z-index: 1;
    filter: drop-shadow(2px 2px 6px var(--mgp-dark));
    text-transform: initial;
  }
  .text-bubble {
    position: relative;
    font-size: 1rem;
    padding: 1rem;
    z-index: 1;
    border-radius: 7px;
    background-color: var(--mgp-purple-900);
    color: var(--mgp-cream);
    border: 2px solid #e1b828;
    font-weight: 400;
    line-height: 1.5rem;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    animation: scaleup 0.3s ease-in-out;
    transform-origin: var(--carret-position) 100%;
  }
  .text-bubble:before {
    content: '';
    position: absolute;
    top: 101%;
    left: var(--carret-position);
    border-top: 12px solid #e1b828;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
  }
  .text-bubble:after {
    content: '';
    position: absolute;
    top: 96%;
    left: var(--carret-position);
    border-top: 12px solid #012738;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
  }
</style>
